
import { Options, Vue } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import {
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
} from "mdb-vue-ui-kit";
import { Skeleton } from "@progress/kendo-vue-indicators";
import { useAuthStore } from "../../../stores/auth";
import { asureIdentity } from "../../../services/auth/asure-identity";

@Options({
  components: {
    Skeleton,
    MDBModal,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
  },
})
export default class PtmLogoutModal extends Vue {
  @Prop() showModalProp: any;
  showModal: any = false;
  confLogoutMsg = "Do you want to sign out?";

  mounted() {
    this.showModal = this.showModalProp;
  }
  updated() {
    this.showModal = this.showModalProp;
  }
  closeModal() {
    this.showModal = false;
    this.$emit("closeModalPopup", this.showModal);
  }
  logoutApp() {
    const authStore = useAuthStore();
    authStore.clearUser();
    authStore.clearCurrentClientObject();
    asureIdentity.signOut();
  }
}
